import { Snackbar, Alert, alpha, useTheme } from "@mui/material";
import { Bookmark } from "lucide-react";
import { Tiny } from "components/Typography";
import FlexBox from "components/flexbox/FlexBox";
import { useNavigate } from "react-router-dom";

export default function BookmarkAlert({ open, onClose }) {
  const theme = useTheme();
  const navigate = useNavigate();

  const handleCloseAlert = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    onClose();
  };

  return (
    <Snackbar
      open={open}
      autoHideDuration={2000}
      onClose={handleCloseAlert}
      anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
    >
      <Alert
        onClose={handleCloseAlert}
        severity="success"
        sx={{
          width: "100%",
          position: "relative",
          maxWidth: "100%",
          bgcolor: alpha("#000000", 0.7),
          color: "#FFFFFF",
          "& .MuiAlert-icon": {
            display: "none",
          },
          borderRadius: "100px",
          "& .MuiAlert-action": {
            display: "none",
          },
          padding: "6px 16px",
        }}
      >
        <FlexBox
          alignItems="center"
          flexDirection="row"
          justifyContent="space-between"
          width="100%"
          sx={{
            boxSizing: "border-box",
            maxWidth: "100%",
          }}
        >
          <FlexBox alignItems="center" gap={1} mr={12}>
            <Bookmark size={16} color="#FFFFFF" />이 게시글을 스크랩했습니다.
          </FlexBox>
          <FlexBox>
            <Tiny
              onClick={() => navigate("/naver/community/bookmark")}
              sx={{
                position: "absolute",
                right: 20,
                bottom: 12,
                cursor: "pointer",
                color: theme.palette.primary.white,
                "&:hover": { textDecoration: "underline" },
              }}
            >
              전체보기
            </Tiny>
          </FlexBox>
        </FlexBox>
      </Alert>
    </Snackbar>
  );
}
